<template>
  <UiCard title="Collections Released">
    <template #title-right>
      <PeriodSelector
        v-model="period"
        :periods="['7d', '30d', '90d', '180d', '1y', '2y']"
        :max-enabled="5 * 365 * 24 * 60 * 60"
      />
    </template>

    <UiCardBody>
      <Chart
        :options="chartOptions"
        :is-loading="loading"
        watermark
      />
    </UiCardBody>
  </UiCard>
</template>

<script setup>
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { ref, computed } from 'vue';
import moment from 'moment';
import { formatNumber } from '@/utils/filters';
import newMintsPerDayQuery from '@/graphql/chart-data/queries/newMintsPerDay.query.gql';
import UiCard from '../ui/UiCard.vue';
import PeriodSelector from '../PeriodSelector.vue';
import UiCardBody from '../ui/UiCardBody.vue';
import Chart, { createTooltip } from '../Chart.vue';

const period = ref('1y');

const {
  result,
  loading,
} = useQuery(newMintsPerDayQuery, () => ({ period: period.value }));

const chartOptions = computed(() => ({
  xAxis: {
    type: 'datetime',
  },

  tooltip: createTooltip({
    formatters: {
      'New collections': (value) => formatNumber(value),
    },
  }),
  plotOptions: {
    column: {
      dataLabels: {
        enabled: false,
      },
    },
  },
  legend: {
    enabled: false,
  },
  series: [
    {
      data: result.value?.newMintsPerDay?.map((item) => [
        parseInt(moment(item.key).format('x')),
        item.value,
      ]) || [],
      type: 'column',
      name: 'New collections',
    },
  ],
}));

</script>
